module.exports = __webpack_public_path__ + "static/media/book-open-solid-dark.915e5092.png";